import React from 'react'
import PropTypes from 'prop-types'
import { DialogActions, DialogTitle, DialogContentText, Dialog, Button, DialogContent } from '@mui/material'

const ReuseConfirmationDialog = ({
    handleConfirm,
    handleCancel,
    title,
    open,
    children,
}) => {
    const handleClose = function () {
        handleCancel()
    }
    const onConfirm = function () {
        handleConfirm()
    }

    return (
        <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle onClose={handleClose}>
                {title}
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button disableElevation onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button disableElevation
                    onClick={onConfirm}
                    variant="contained"
                    color="primary"
                >
                    Confirm
                </Button>

            </DialogActions>
        </Dialog>
    )
}
ReuseConfirmationDialog.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}

export default ReuseConfirmationDialog
